import Content from './Content';

// export types
export type { ContentProps } from './Content';

// export components
export { Content };
export default Content;
